// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i0bCl","field":"styles_field__1Nf4f","fieldCol":"styles_fieldCol__27HPX","diffCol":"styles_diffCol__1F9WF","diff":"styles_diff__1gVgM"};